/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-18 12:36:35
 * @modify date 2023-10-18 12:36:35
 * @desc 내 정보 화면을 정의한다.
 */


import {
    StyleSheet, View, Text
} from "react-native";

import { parseLocaleDatetime } from "../../../common/util";
import { FONT } from "../../../value/staticValues";
import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";
import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as AdminImg } from "../../../img/ico-login-admin-white.svg";
import { ReactComponent as DomainImg } from "../../../img/ico-login-domain.svg";
import { MyInfoData } from "./MyInfoData";



interface MyInfoDetailProps extends ContentContainerProps {
    updateAccountFunction: Function;
    changePasswordFunction: Function;
    detailData: MyInfoData;
}



export default function MyInfoDetail(props:MyInfoDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("ACCOUNT_MGMT_DETAIL")} subtitle={t("ACCOUNT_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: 840, marginRight: 10}}>
                        <View style={{...style.boxContainer, height: 320}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                                <Text style={style.boxContentTitle}>
                                    {t("ACCOUNT_DETAIL_INFO_TEXT")}
                                </Text>
                                <div
                                    style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                    onClick={(e) => {props.updateAccountFunction()}}
                                >
                                    <TableEditImg/>
                                    <Text style={{
                                        marginLeft: 2,
                                        fontFamily: FONT.MEDIUM,
                                        fontSize: 12,
                                        color: "#3c5df2"
                                    }}>
                                        {t("INFO_EDIT_TEXT")}
                                    </Text>
                                </div>
                            </View>

                            <View style={{flexDirection: "row"}}>
                                <View style={{width: 490}}>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("ACCOUNT_TYPE_TEXT")}
                                        </Text>
                                        <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                            {
                                                props.detailData.user_role_type_code ? 'Admin' : 'User'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("ACCOUNT_STATUS_TEXT")}
                                        </Text>
                                        <View style={{ flexDirection: "row", alignItems: "center",}}>
                                            {
                                                props.detailData.user_status_code === "ACT" ? <StatusStableImg/> : <StatusBlockImg/>
                                            }
                                            <Text style={{
                                                fontFamily: FONT.REGULAR,
                                                fontSize: 12,
                                                color: props.detailData.user_status_code === "ACT" ? "#3a8344" : "#8c8c8c",
                                            }}>
                                                {t("ACTIVE_TEXT")}
                                            </Text>
                                        </View>
                                    </View>

                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("ACCOUNT_ID_TEXT")}
                                        </Text>
                                        <Text style={style.boxContentDataText}>
                                            {props.detailData.email}
                                        </Text>
                                    </View>

                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("PASSWORD_TEXT")}
                                        </Text>
                                        <div style={{fontFamily: FONT.MEDIUM, fontSize: 14, color: "#3a8344", textDecoration: "underline", cursor:"pointer"}}
                                        onClick={(e)=>{props.changePasswordFunction()}}>
                                            {t("CHANGE_PASSWORD_TEXT")}
                                        </div>
                                    </View>
                                </View>


                                <View style={{width: 260, alignItems: "center"}}>
                                    {
                                        props.detailData.user_role_type_code === "ADM" ?
                                            <View style={{...style.boxAccounRole}}>
                                                <AdminImg style={style.boxAccounrRoleImg}/>
                                                <Text style={{...style.boxAccountRoleText}}>Admin</Text>
                                            </View>
                                        :
                                            <View style={{...style.boxAccounRole, backgroundColor: "#64c6a4"}}>
                                                <DomainImg style={style.boxAccounrRoleImg}/>
                                                <Text style={{...style.boxAccountRoleText}}>User</Text>
                                            </View>


                                    }
                                    <Text style={style.dateUpdate}>{props.detailData.update_ts ? parseLocaleDatetime(props.detailData.update_ts) + " " + t("LAST_UPDATE_TEXT") : ""}</Text>
                                    <Text style={style.dateCreate}>{props.detailData.create_ts ? parseLocaleDatetime(props.detailData.create_ts) + " " + t("CREATE_TEXT") : ""}</Text>
                                </View>
                            </View>
                        </View>

                        <View style={{...style.boxContainer, height: 210}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                                <Text style={style.boxContentTitle}>
                                    {t("BASE_INFO_TEXT")}
                                </Text>
                                <Text style={style.boxContentTitleDescription}>
                                    {t("ACCOUNT_BASE_INFO_TITLE_DESCRIPTION_MESSAGE")}
                                </Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("NAME_TEXT")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData.fullname}
                                </Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("PHONE_NUMBER_TEXT")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData.phone_number}
                                </Text>
                            </View>
                        </View>

                        <View style={{...style.boxContainer, height: 260}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                                <Text style={style.boxContentTitle}>
                                    {t("GROUP_INFO_TEXT")}
                                </Text>
                                <Text style={style.boxContentTitleDescription}>
                                    {t("ACCOUNT_GROUP_INFO_TITLE_DESCRIPTION_MESSAGE")}
                                </Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("ORGANIZATION_NAME_TEXT")}
                                </Text>
                                    {
                                        props.detailData.company_name ?
                                        <Text style={style.boxContentDataText}>
                                            {props.detailData.company_name}
                                        </Text>
                                        :<Text style={style.boxContentEmptyDataText}>
                                            {t("EMPTY_INFO_TEXT")}
                                        </Text>
                                    }
                            </View>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("ORGANIZATION_DEPARTMENT_TEXT")}
                                </Text>
                                    {
                                        props.detailData.department_name ?
                                        <Text style={style.boxContentDataText}>
                                            {props.detailData.department_name}
                                        </Text>
                                        :<Text style={style.boxContentEmptyDataText}>
                                            {t("EMPTY_INFO_TEXT")}
                                        </Text>
                                    }
                            </View>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("ORGANIZATION_POSITION_TEXT")}
                                </Text>
                                    {
                                        props.detailData.department_rank ?
                                        <Text style={style.boxContentDataText}>
                                            {props.detailData.department_rank}
                                        </Text>
                                        :<Text style={style.boxContentEmptyDataText}>
                                            {t("EMPTY_INFO_TEXT")}
                                        </Text>
                                    }
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateUpdate: {
        marginTop: 25,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateCreate: {
        marginTop: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentTitleDescription: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c",
        marginLeft: 10
    },
    boxContentHeaderText: {
        width: 70,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentEmptyDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#acb0bf"
    },
    boxContentDataDescription: {
        marginTop: 15,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#9ea0a5"
    },
    boxAccounRole: {
        width: 100,
        height: 100,
        marginTop: -18,
        backgroundColor: "#4f5fd8",
        borderRadius: 60,
        alignItems:"center",
        justifyContent: "center"
    },
    boxAccountRoleText: {
        fontFamily: FONT.MEDIUM,
        fontSize: 12,
        color: "#fff"
    },
    boxAccounrRoleImg: {
        width: 50,
        height: 50,
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 70,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        padding: 20,
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 75,
        marginRight: 90,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        fontFamily: FONT.BOLD,
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
});